<script>
export default {
  functional: true,
  props: ['attributes'],
  render (h, {props}) {
    const {value, maxwidth} = props.attributes
    return h('div', {class: 'fb-post-container'}, [
      h('div', {
        class: ['fb-post'],
        style: {
          maxWidth: maxwidth || 'auto'
        },
        attrs: {
          'data-href': value,
          'data-show-text': true
        }
      })
    ])
  }
}
</script>

<style lang="scss">
.fb-post-container {
  .fb-post.fb_iframe_widget {
    max-width: 500px;
    display: block;
    margin: 0 auto;

    & > * {
      max-width: 100% !important;
      width: 100% !important;

      iframe {
        max-width: 100% !important;
        width: 100% !important;
      }
    }
  }
}
</style>
